import styled from 'styled-components';

export const MasonryItemElement = styled.div`
  break-inside: avoid-column;
  margin-bottom: 30px;
`;
